import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup as MaterialRadioGroup,
} from '@material-ui/core';
import cls from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { useRadioGroupStyles } from './styles';

const RadioGroup = ({
  'data-testid': dataTestId,
  classes: customClasses,
  disabled,
  horizontal,
  label,
  name,
  onChange,
  options,
  value,
}) => {
  const classes = useRadioGroupStyles({ horizontal });
  const items = useMemo(
    () => options.map((item, idx) => (
      <FormControlLabel
        classes={{
          label: classes.label,
        }}
        disabled={disabled}
        key={item.value}
        label={item.label}
        value={item.value}
        className={customClasses.controlLabel}
        checked={item.value === value}
        control={(
          <Radio
            disabled={disabled}
            color="primary"
            data-testid={dataTestId ? `${dataTestId}-${idx}` : dataTestId}
            className={customClasses.item}
          />
          )}
      />
      // eslint-disable-next-line react-hooks/exhaustive-deps
    )),
    [JSON.stringify(options), value, dataTestId, disabled]
  );

  return (
    <FormControl component="fieldset" className={customClasses.fieldset}>
      {label && (
        <FormLabel component="legend" className={customClasses.label}>
          {label}
        </FormLabel>
      )}
      <MaterialRadioGroup
        className={cls(classes.radioGroup, customClasses.radioGroup)}
        aria-label={name}
        name={name}
        value={value}
        onChange={onChange}
      >
        {items}
      </MaterialRadioGroup>
    </FormControl>
  );
};

RadioGroup.propTypes = {
  'data-testid': PropTypes.string,
  classes      : PropTypes.objectOf(PropTypes.string),
  disabled     : PropTypes.bool,
  horizontal   : PropTypes.bool,
  label        : PropTypes.string,
  name         : PropTypes.string,
  onChange     : PropTypes.func.isRequired,
  options      : PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

RadioGroup.defaultProps = {
  'data-testid': undefined,
  classes      : {},
  disabled     : false,
  horizontal   : false,
  label        : undefined,
  name         : undefined,
  value        : null,
};

export default RadioGroup;
